class NotifyMeToggle extends HTMLElement {
   connectedCallback() {
      try {
         const dataAttr = this.getAttribute('data-notify-me-config') || '{}';
         this.config = JSON.parse(dataAttr);

         this.notifyMeButton = this.querySelector('#openModalButton');
         this.unavailableButton = this.querySelector('#unavailableButton');

         // Find the product form to listen for variant:change
         const formId = this.getAttribute('data-form-id');
         this.productForm = formId ? document.forms[formId] : null;

         if (this.productForm) {
            this._onVariantChangedListener = this._onVariantChanged.bind(this);
            this.productForm.addEventListener('variant:change', this._onVariantChangedListener);
         }
      } catch (e) {
         console.error('NotifyMeToggle init error:', e);
      }
   }

   disconnectedCallback() {
      if (this.productForm && this._onVariantChangedListener) {
         this.productForm.removeEventListener('variant:change', this._onVariantChangedListener);
      }
   }

   _onVariantChanged(event) {
      const variant = event.detail.variant;
      if (!variant) return;

      const variantId = String(variant.id);
      const isAvailable = variant.available && variant.inventory_quantity > 0;

      // Update the VPV store for the BIS modal
      if (window.__VPV && window.__VPV.store) {
         window.__VPV.store.selectedVariant = variant.id;
      }

      // Check if notify me should be hidden for this variant
      const shouldHideNotifyMe = this._shouldHideNotifyMe(variantId);

      if (!this.notifyMeButton || !this.unavailableButton) return;

      if (isAvailable) {
         // Product is in stock — hide both notify me and unavailable
         this.notifyMeButton.classList.add('hidden');
         this.unavailableButton.classList.add('hidden');
      } else if (shouldHideNotifyMe) {
         // Out of stock + toggle says hide notify me — show unavailable
         this.notifyMeButton.classList.add('hidden');
         this.unavailableButton.classList.remove('hidden');
      } else {
         // Out of stock + notify me allowed — show notify me
         this.notifyMeButton.classList.remove('hidden');
         this.unavailableButton.classList.add('hidden');
      }
   }

   /**
    * Determine whether to hide the Notify Me button for a given variant.
    *
    * Logic:
    *   - Variant metafield is true  → hide (show Unavailable)
    *   - Variant metafield is false → show Notify Me (override product)
    *   - Variant metafield is null  → fall back to product metafield
    *       - Product is true  → hide (show Unavailable)
    *       - Product is false/null → show Notify Me
    */
   _shouldHideNotifyMe(variantId) {
      const variantToggle = this.config.variants?.[variantId];

      // Variant explicitly set
      if (variantToggle === true) return true;
      if (variantToggle === false) return false;

      // Variant is null/undefined — fall back to product level
      if (this.config.productToggle === true) return true;

      return false;
   }
}

customElements.define('notify-me-toggle', NotifyMeToggle);